
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"fillCurrent","d":"M.346 5.557a.62.62 0 00-.149.454.62.62 0 00.217.427l3.084 2.644a.62.62 0 00.462.148.623.623 0 00.428-.226l5.276-6.421a.622.622 0 00-.086-.88L8.612.908a.626.626 0 00-.88.086l-4.06 4.942L2.041 4.54a.627.627 0 00-.882.067l-.813.95z"}})])
          )
        }
      }
    